import { createSlice } from "@reduxjs/toolkit";
import {
  getMainPageSlice,
} from '@store/features/filters/MainPageSlice/MainPageSlice';
import { useSelector } from "react-redux";

const rigElement = {
  rigName: null,
  selectedEquipmentName: null,
  isEquipmentSelected: false,
  selectedEquipmentLookup: [{ value: 0, name: 'All' }]
}

const initialState = {
  rigs: [rigElement]
}

const getSessionState = () => {
  try {
    const serializedState = sessionStorage.getItem(APP_NAME);
    if (!serializedState) return undefined;
    const stateObj = JSON.parse(serializedState);
    if (stateObj.version !== STORE_VERSION) {
      return undefined;
    }
    return stateObj.filters.rigs;
  } catch (e) {
    return undefined;
  }
};
const RigSlice = createSlice({
  name: 'RigOverviewStorage',
  initialState: getSessionState() ?? initialState,
  reducers: {
    resetRigStorageState: () => initialState,
    setSelectedEquipmentName: (state, action) => {
      const { rigName, selectedEquipmentName  } = action.payload;
      const currentSettings = createIfNotExistRigElement(state, rigName);
      currentSettings.selectedEquipmentName = selectedEquipmentName;
    },
    setIsEquipmentSelectedFlag: (state, action) => {
      const { rigName, isEquipmentSelected } = action.payload;
      const currentSettings = createIfNotExistRigElement(state, rigName);
      currentSettings.isEquipmentSelected = isEquipmentSelected;
    }
  }
});

function createIfNotExistRigElement(state, selectedRigName) {
  let currentSettings = state.rigs.find(r => r.rigName === selectedRigName);
  if (!currentSettings) {
    let newRigSettings = {
      rigName: selectedRigName,
      selectedEquipmentName: null,
      isEquipmentSelected: false,
      selectedEquipmentLookup: [{ value: 0, name: 'All' }]
    };
    state.rigs.push(newRigSettings);
    currentSettings = newRigSettings;
  }

  return currentSettings;
}

export const getRigSlice = (state, selectedRigName) => {
  return state.filters.rigs.rigs.find(({rigName}) => rigName === selectedRigName); 
};

export const getSelectedEquipmentName = (state, selectedRigName) => {
  const currentSettings = state.filters.rigs.rigs.find(({rigName}) => rigName === selectedRigName);

  return currentSettings?.selectedEquipmentName;
};

export const getIsEquipmentSelected = (state, selectedRigName) => {
  const currentSettings = state.filters.rigs.rigs.find(({rigName}) => rigName === selectedRigName);

  return currentSettings?.isEquipmentSelected;
};

export const {
  setSelectedEquipmentName,
  setIsEquipmentSelectedFlag
} = RigSlice.actions;

export default RigSlice.reducer;